import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { useHistory } from 'react-router-dom';
import logoCalfImage from 'assets/img/logo_calf.png';
import CambioClaveForm from 'components/CambioClaveForm';

const CALF_GREEN     = '#8ebf63';
const CALF_GREEN_DIG = '#39a82d';
const CALF_DARK      = '#023d03';
const CALF_BLACK     = '#161616';
const CALF_LIGHT     = '#bee59a';

function CambioClave() {
  const history = useHistory();
  const [showCancelError, setShowCancelError] = useState(false);

  const handleSuccess = () => {
    history.push('/admin');
    window.location.reload();
  };

  const handleCancel = () => {
    if (localStorage.getItem('cambio') === 'S') {
      setShowCancelError(true);
    } else {
      history.push('/admin');
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', backgroundColor: CALF_BLACK }}>

      {/* IZQUIERDA — branding */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: '50%',
          backgroundColor: CALF_DARK,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={logoCalfImage}
          alt="CALF"
          style={{ width: 280, height: 'auto', filter: 'brightness(0) invert(1)' }}
        />
        <Typography
          sx={{
            fontFamily: "'Nohemi', Arial, sans-serif",
            fontWeight: 300,
            fontSize: '1.1rem',
            color: CALF_LIGHT,
            mt: 3,
            letterSpacing: 2,
            textTransform: 'uppercase',
          }}
        >
          Sistema de Gestion
        </Typography>
        <Box sx={{ width: 60, height: 3, bgcolor: CALF_GREEN, borderRadius: 2, mt: 3 }} />
      </Box>

      {/* DERECHA — formulario */}
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 4 }}>
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            maxWidth: 400,
            backgroundColor: 'rgba(255,255,255,0.05)',
            borderRadius: 3,
            p: 4,
            border: '1px solid rgba(142,191,99,0.2)',
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Nohemi', Arial, sans-serif",
              fontWeight: 600,
              fontSize: '1.8rem',
              color: '#ffffff',
              mb: 1,
            }}
          >
            Cambio de Contraseña
          </Typography>
          <Typography
            sx={{
              color: 'rgba(255,255,255,0.5)',
              fontSize: '0.85rem',
              mb: 4,
            }}
          >
            Actualizá tu contraseña
          </Typography>

          <CambioClaveForm
            dark
            onSuccess={handleSuccess}
            onCancel={handleCancel}
          />

          <Collapse in={showCancelError}>
            <Alert severity="warning" sx={{ mt: 2, borderRadius: 2 }} onClose={() => setShowCancelError(false)}>
              Debe actualizar la contraseña antes de continuar
            </Alert>
          </Collapse>
        </Paper>
      </Box>
    </Box>
  );
}

export default CambioClave;
